var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      class: {
        [`spinner-${_vm.type}`]: true,
        [`spinner-${_vm.type}-sm`]: _vm.small,
        [`text-${_vm.color}`]: true,
      },
      attrs: { role: "status" },
    },
    [
      _c("span", { staticClass: "sr-only" }, [
        _vm._v(_vm._s(_vm._f("localized")("Review.View.Loading.1"))),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }